import {postRequest} from "../../../middlewares/api/actions";
import {getDataBrowserClearAllCacheUrl} from "../../../constants/urls";

const UPDATE_DATABROWSER_CACHE = "UPDATE_DATABROWSER_CACHE";

export const onUpdateDatabrowserCache = () => postRequest(
  UPDATE_DATABROWSER_CACHE,
getDataBrowserClearAllCacheUrl(),
  {},
  t => ({
    success: t('scenes.dataManager.updateDatabrowserCache.messages.updateDatabrowserCache.success')
  })
);